"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
function getUserRole({ id, domainId }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const priority = {
                SCHOOL_ADMIN: 1,
                TEACHER: 2,
                STUDENT: 3
            };
            const domainsRef = yield app_1.app.firestore.collection('users').doc(id);
            if (id) {
                return yield domainsRef.get().then(doc => {
                    if (doc.exists) {
                        const data = doc.data();
                        let currentPri = 4;
                        data.permissions.forEach(d => {
                            if (priority[d.role] < currentPri && domainId === d.domainId) {
                                currentPri = priority[d.role];
                            }
                        });
                        if (currentPri === 1) {
                            return identifiers_1.Types.UserPermissionRoles.SCHOOL_ADMIN;
                        }
                        else if (currentPri === 2) {
                            return identifiers_1.Types.UserPermissionRoles.TEACHER;
                        }
                        else {
                            return identifiers_1.Types.UserPermissionRoles.STUDENT;
                        }
                    }
                    else {
                        console.log('No such document!');
                        return null;
                    }
                });
            }
            else {
                return null;
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = getUserRole;
//# sourceMappingURL=getUserRole.js.map